import { Slide } from '@features/powerpoint';
import { DEFAULT_SLIDE_MASTER } from '../../../slides/slide-master';
import { CampaignAnalyticsReport } from '@components/Dashboard/CampaignAnalytics/slice/schema';
import { contentSlideTitleText } from '../../../slides/content-slide-title-text';
import { statesTable } from './top-states-dmas-locations/states-table';
import { dmasTable } from './top-states-dmas-locations/dmas-table';
import { brandLocationsTable } from './top-states-dmas-locations/brand-locations-table';

type TopStatesDmasLocationsSlideOptions = {
  stateVisits: CampaignAnalyticsReport['stateVisits'];
  dmaVisits: CampaignAnalyticsReport['dmaVisits'];
  brandLocationVisits: CampaignAnalyticsReport['brandLocationVisits'];
};

export const topStatesDmasLocationsSlide = (
  options: TopStatesDmasLocationsSlideOptions
): Slide => {
  return {
    slideMaster: DEFAULT_SLIDE_MASTER,
    texts: [
      contentSlideTitleText(
        '<b>Top 10</b> <lci>States, DMAs & Locations</lci>'
      ),
    ],
    tables: [
      statesTable(options.stateVisits),
      dmasTable(options.dmaVisits),
      brandLocationsTable(options.brandLocationVisits),
    ],
  };
};
